export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  filters: {
    keyword: "",
    advanced: {
      name: null,
      jobFoundMethod: null,
      didOdysseaSupport: null,
      branch: null,
      employerName: null,
      partOfNetwork: null,
      fieldOfEmployment: null,
      jobTitleId: null,
      typeOfEmployment: null,
      durationOfContract: null,
      netSalaryRange: [],
      dateDates: [],
      startDates: [],
      endDates: [],
      route: [],
      trainingType: [],
      odysseaSupport: null,
      socialSecurity: null,
      jobSatisfactionLevel: null,
      helpsGrow: null,
      feelSecureInJob: null,
      getAlong: null,
      jobMatchSkills: null,
      recommendEmployer: null,
      stillLookingForJob: null,
      newJobLookingFor: null,
      intakeProjects: [],
    },
  },
});
